/* eslint-disable */
import React, { useState, useEffect } from 'react';

import {
    Checkbox,
    Grid,
    TextField,
    IconButton,
    TableCell,
    TableRow,
    Tooltip,
    Typography,
    Menu,
    MenuItem,
    Box,
    useTheme,
    DialogContent,
    Avatar,
    Button,
    Dialog,
    DialogActions,
    DialogTitle,
    DialogContentText,
    InputLabel,
    Select,
    Stack,
    LinearProgress
} from '@mui/material';

import FileDownloadDoneIcon from '@mui/icons-material/FileDownloadDone';
import { Chip } from '@mui/material'; // Import Chip component
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import WarningIcon from '@mui/icons-material/Warning';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ArticleIcon from '@mui/icons-material/Article';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import useAuth from 'hooks/useAuth';
import InfoIcon from '@mui/icons-material/Info';

import { archievedStatus, propertyStatus, roles } from 'store/constant';
import { useLocation, useNavigate } from 'react-router-dom';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import axiosServices from 'utils/axios';

import MoreVertIcon from '@mui/icons-material/MoreVert';
import { VpnKeyOutlined } from '@mui/icons-material';
import ArchiveIcon from '@mui/icons-material/Archive';
import RestoreIcon from '@mui/icons-material/Restore';
import { excludedKeys, keyItemsPairs } from './validation';
import EditedDataModal from './Details/EditedDataModal';
import moment from 'moment';
import { LoadingButton } from '@mui/lab';
import { useDispatch } from 'react-redux';
import { ListingActions } from 'store/slices/listings';
import { toast } from 'react-toastify';
import PublishButton from './ProgressButton';

function ListingTableRow({
    row,
    index,
    selected,
    onSelectRow,
    detailedView,
    handleApproveRequest,
    handleRejectRequest,
    handleArchieve,
    handleEdit,
    handleDelete,
    openShareAccess,
    handleRestore,
    createNewComplexDuplicateLisitng,
    createNewEntireDuplicateLisitng,
    handleDuplicate,
    myData,
    handleAnalyticsOpen,
    handleApproveArchieveRequest,
    terms,
    setOpenTerms,
    termsReqSend
}) {
    const { role } = useAuth();
    const navigate = useNavigate();

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const { pathname } = useLocation();
    const url = pathname.split('/').pop();

    const isArchivedPage = url === 'archived-listing' || url === 'trashed-listing';

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const theme = useTheme();
    // State to store the keys found in editedData
    const [editedData, setEditedData] = useState({});
    const [oldValueCount, setOldValueCount] = useState(0);
    const [highlightedKeys, setHighlightedKeys] = useState([]);
    const [currentEditedData, setcurrentEditedData] = useState({});

    const [openEdited, setOpenEdited] = useState(false);
    const handleOpenEdited = () => setOpenEdited(true);
    const handleCloseEdited = () => setOpenEdited(false);
    const { editListings } = ListingActions;
    const [openModal, setOpenModal] = useState(false);
    const dispatch = useDispatch();

    const handleOpenModal = () => setOpenModal(true);
    const handleCloseModal = () => setOpenModal(false);

    const [loading, setLoading] = useState(false);

    const [modalInputs, setModalInputs] = useState({
        listPrice: row?.listingInformation?.listPrice,
        unit: row?.locationInformation?.unit
    });

    const handleModalOpening = (row) => {
        if (row?.history?.length) {
            setcurrentEditedData(row?.history[0]);
            handleOpenEdited();
        }
    };

    useEffect(() => {
        if (row?.history?.length) {
            setEditedData(row?.history[0]?.editedData);
        }
    }, [row]);

    // Check for key items in editedData and update state
    useEffect(() => {
        const findKeysInData = (data) => {
            try {
                let foundKeys = [];
                const traverse = (obj) => {
                    for (let key in obj) {
                        if (keyItemsPairs.includes(key)) {
                            foundKeys.push(key);
                        }
                        if (typeof obj[key] === 'object') {
                            traverse(obj[key]); // Check nested objects
                        }
                    }
                };
                traverse(editedData); // Start with the editedData
                setHighlightedKeys(foundKeys);
            } catch (e) {
                // console.log('Key Items', e);
            }
        };

        const countOldValues = (data) => {
            try {
                let count = 0;

                const traverse = (obj, parentKey = '') => {
                    for (let key in obj) {
                        if (excludedKeys.includes(parentKey)) {
                            continue; // Skip ignored parent keys
                        }
                        if (key === 'oldValue' && obj[key] !== null) {
                            count++;
                        } else if (typeof obj[key] === 'object') {
                            traverse(obj[key], key); // Check nested objects
                        }
                    }
                };

                traverse(data);
                setOldValueCount(count);
            } catch (e) {
                // console.log('Count Items', e);
            }
        };

        // Initialize the data
        if (editedData && row?.currentStatus === propertyStatus?.DEFAULT) {
            findKeysInData(editedData);
            if (role === roles.ADMIN) {
                countOldValues(editedData);
            }
        }
    }, [editedData]);

    function getTimeDifference(passedDate, option) {
        // Parse the passed date
        const date1 = new Date(passedDate);

        // Get today's date
        const date2 = new Date();

        // Calculate the difference in time (milliseconds)
        const timeDifference = date2 - date1;

        // Convert time difference from milliseconds to days and hours
        const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
        const hoursDifference = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

        // If the difference is more than a day, return the day difference
        if (daysDifference > 0) {
            return `${option === 'create' ? 'Created' : 'Updated'}  ${daysDifference} day${daysDifference > 1 ? 's' : ''} ago`;
        }
        // If the difference is less than a day, return the hour difference
        else if (hoursDifference > 0) {
            return `${option === 'create' ? 'Created' : 'Updated'} ${hoursDifference} hour${hoursDifference > 1 ? 's' : ''} ago`;
        }
        // If the difference is less than an hour, return 'just now'
        return `${option === 'create' ? 'Created' : 'Updated'} just now`;
    }

    const handlePublish = async () => {
        try {
            setLoading(true);

            if (!modalInputs?.listPrice || !modalInputs?.unit) {
                setLoading(false);
                toast.error('Please fill all the fields');
                return;
            }

            if (row.completion <= 99) {
                setLoading(false);
                toast.error('Please complete your listing details before submit.');
                return;
            }

            const data = {
                listingInformation: {
                    listPrice: modalInputs?.listPrice
                },
                locationInformation: {
                    unit: modalInputs?.unit
                },
                listingStatus: 'PENDING'
            };

            await dispatch(
                editListings({
                    values: data,
                    id: row?.id
                })
            );

            setLoading(false);
        } catch (error) {
            // console.log(error);
            setLoading(false);
        } finally {
            handleCloseModal();
        }
    };

    // Lease and Duplicate Variables and State
    const [selectedDate, setSelectedDate] = useState(null);
    const [dateError, setDateError] = useState(false);

    const handleDateChange = (newValue) => {
        setSelectedDate(newValue);
        setDateError(false);
    };

    const [openLease, setOpenLease] = React.useState(false);

    const handleOpenLease = () => setOpenLease(true);
    const handleCloseLease = () => setOpenLease(false);

    const [openTwo, setOpenTwo] = React.useState(false);
    const [openThree, setOpenThree] = React.useState(false);
    const [unitNm, setUnitNm] = useState(null);

    const handleOpenTwo = () => {
        setOpenLease(false);
        setOpenTwo(true);
    };
    const handleCloseTwo = () => setOpenTwo(false);

    const handleArchieveAndCreateNew = async (emptyUnit = false) => {
        try {
            setLoading(true);
            const { data: returnedData } = await axiosServices.post(`property/leaseAndDuplicate`, {
                leaseDate: selectedDate,
                property_id: row.id,
                unit: emptyUnit && !unitNm ? '' : unitNm
            });

            if (unitNm) {
                if (returnedData?.length >= 2) {
                    window.open(`/listing/${returnedData[1]?.id}`, '_self');
                    toast.success('Listing has been duplicated successfully');
                } else {
                    toast.error('Error in duplicating the listing');
                }
            } else {
                window.open(`/listing/manage-listing`, '_self');
                toast.success('Listing has been archieved successfully');
            }

            setOpenTwo(false);
            setOpenThree(false);
            setLoading(false);
        } catch (error) {
            // console.log(error);
            toast.error('Something went wrong');
            setLoading(false);
        }
    };

    const getBorderColor = (status, completition) => {
        if (status === 'NONE' && completition === 100) {
            return '#1AA90D';
        }
        return status === 'NONE' ? '#C18C48' : status === 'PENDING' ? '#1AA90D' : status === 'APPROVED' ? '#0E7AF0' : '#C18C48';
    };

    const getBodyColor = (status, completition) => {
        if (status === 'NONE' && completition === 100) {
            return '#1AA90D';
        }
        return status === 'NONE' ? '#AD7126' : status === 'PENDING' ? '#1AA90D' : status === 'APPROVED' ? '#0E7AF0' : '#AD7126';
    };

    const getText = (status, completition) => {
        if (status === 'NONE' && completition === 100) {
            return 'Completed';
        }

        return status === 'NONE' ? 'Draft' : status === 'PENDING' ? 'Completed' : status === 'APPROVED' ? 'Live' : 'Draft';
    };

    const [managers, setManagers] = useState([]);

    const renderManagers = (names) => {
        if (!names) return <></>;
        const splittedNames = names.split(',');

        if (splittedNames.length === 1) {
            return (
                <Grid container alignItems="center" justifyContent="center" flexDirection="row" gap="5px">
                    <Typography
                        align="left"
                        variant="subtitle1"
                        component="div"
                        sx={{ width: 'max-content', justifyContent: 'center', textAlign: 'center' }}
                        onClick={() => {
                            if (role !== roles.ADMIN) return;

                            const accessUsers = row?.specialUserAccess?.filter((e) => e?.user?.roleName === roles.APARTMENT_MANAGER);

                            if (accessUsers?.length) {
                                const id = accessUsers[0]?.user?.id;
                                navigate(`/customers/${id}`);
                            }
                        }}
                    >
                        {names}
                    </Typography>
                </Grid>
            );
        }

        return (
            <Grid container alignItems="center" justifyContent="center" flexDirection="row" gap="5px">
                <Typography
                    align="left"
                    variant="subtitle1"
                    component="div"
                    sx={{ width: '120px', justifyContent: 'center', textAlign: 'center' }}
                    onClick={() => {
                        if (role !== roles.ADMIN) return;

                        const accessUsers = row?.specialUserAccess?.filter((e) => e?.user?.roleName === roles.APARTMENT_MANAGER);
                        if (accessUsers?.length) {
                            const id = accessUsers[0]?.user?.id;
                            navigate(`/customers/${id}`);
                        }
                    }}
                >
                    {splittedNames[0]} And{' '}
                    <span
                        style={{ color: '#0E7AF0' }}
                        onClick={(e) => {
                            e.stopPropagation();
                            setManagers(splittedNames);
                            handleClickOpen();
                        }}
                    >
                        {splittedNames.length - 1} Others
                    </span>
                </Typography>
            </Grid>
        );
    };

    const [openManagerDialog, setOpenManagerDialog] = React.useState(false);

    const handleClickOpen = () => {
        setOpenManagerDialog(true);
    };

    const handleClose = () => {
        setOpenManagerDialog(false);
    };

    return (
        <>
            <Dialog
                open={openManagerDialog}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle
                    sx={{
                        fontSize: '20px',
                        fontWeight: '700',
                        lineHeight: '27.32px',
                        textAlign: 'left',
                        mt: '-10px'
                    }}
                >
                    All Managers
                </DialogTitle>
                <DialogContent>
                    <Box
                        sx={{
                            border: '1px solid #E6E6E6',
                            p: 2,
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr',
                            gap: 1,
                            borderRadius: '5px'
                        }}
                    >
                        {managers.map((item, i) => (
                            <Typography
                                key={i}
                                sx={{
                                    fontSize: '14px',
                                    fontWeight: 500,
                                    textTransform: 'capitalize'
                                }}
                            >
                                &#x2022; {item}
                            </Typography>
                        ))}
                    </Box>
                </DialogContent>
            </Dialog>

            {/* // PUBLISH FORM //  */}
            <Dialog open={openModal} onClose={handleCloseModal}>
                <DialogTitle>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography sx={{ fontWeight: 'bold', fontSize: '1.2rem' }}>Confirm Publish Listing</Typography>
                    </Box>
                    <Box
                        sx={{
                            mt: 1,
                            borderRadius: '5px',
                            border: '1px solid #E6E6E6',
                            px: '12px',
                            py: '16px'
                        }}
                    >
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography
                                sx={{
                                    color: '#858585',
                                    fontSize: '14px',
                                    fontStyle: 'normal',
                                    fontWeight: '500',
                                    lineHeight: 'normal'
                                }}
                            >
                                Complex Name:
                            </Typography>
                            <Typography
                                sx={{
                                    color: '#272727',
                                    fontSize: '15px',
                                    fontStyle: 'normal',
                                    fontWeight: '500',
                                    lineHeight: 'normal'
                                }}
                            >
                                {row?.generalInformation?.complexName || '-'}
                            </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography
                                sx={{
                                    color: '#858585',
                                    fontSize: '14px',
                                    fontStyle: 'normal',
                                    fontWeight: '500',
                                    lineHeight: 'normal'
                                }}
                            >
                                Floor Plan:
                            </Typography>
                            <Typography
                                sx={{
                                    color: '#272727',
                                    fontSize: '15px',
                                    fontStyle: 'normal',
                                    fontWeight: '500',
                                    lineHeight: 'normal'
                                }}
                            >
                                {row?.generalInformation?.floorPlanName ? row?.generalInformation?.floorPlanName?.split('-').join('') : '-'}
                            </Typography>
                        </Box>
                    </Box>
                </DialogTitle>
                <DialogContent sx={{ display: 'flex', gap: 1 }}>
                    <TextField
                        fullWidth
                        margin="dense"
                        label="Listing Price"
                        value={modalInputs?.listPrice}
                        onChange={(event) => {
                            setModalInputs({ ...modalInputs, listPrice: event.target.value });
                        }}
                        type="number"
                    />
                    <TextField
                        fullWidth
                        margin="dense"
                        label="Unit Number"
                        value={modalInputs?.unit}
                        onChange={(event) => {
                            setModalInputs({ ...modalInputs, unit: event.target.value });
                        }}
                        type="number"
                    />
                </DialogContent>
                <DialogActions>
                    <LoadingButton onClick={handleCloseModal} variant="outlined" sx={{}}>
                        Cancel
                    </LoadingButton>
                    <LoadingButton onClick={handlePublish} color="primary" loading={loading} variant="contained">
                        Submit
                    </LoadingButton>
                </DialogActions>
            </Dialog>

            {/* // Lease AND DUPLICATE FROM // */}
            <Dialog
                open={openLease}
                onClose={handleCloseLease}
                aria-labelledby="responsive-dialog-title"
                sx={{
                    '& .MuiPaper-root': {
                        width: '400px'
                    }
                }}
            >
                {openLease && (
                    <>
                        <DialogTitle
                            sx={{
                                color: '#272727',
                                fontFamily: 'Manrope',
                                fontSize: '20px',
                                fontStyle: 'normal',
                                fontWeight: '700',
                                lineHeight: 'normal',
                                textTransform: 'capitalize'
                            }}
                        >
                            Confirm Unit lease status
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                <Typography variant="body2" component="span">
                                    Please confirm whether the previous unit has been leased.
                                </Typography>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions sx={{ pr: 2.5 }}>
                            <Button autoFocus onClick={handleCloseLease} variant="outlined">
                                No
                            </Button>
                            <LoadingButton type="button" variant="contained" onClick={handleOpenTwo} autoFocus>
                                yes , it is leased
                            </LoadingButton>
                        </DialogActions>
                    </>
                )}
            </Dialog>

            <Dialog
                open={openTwo}
                onClose={handleCloseTwo}
                aria-labelledby="responsive-dialog-title"
                sx={{
                    '& .MuiPaper-root': {
                        width: '400px'
                    }
                }}
            >
                <DialogTitle
                    sx={{
                        color: '#272727',
                        fontFamily: 'Manrope',
                        fontSize: '20px',
                        fontStyle: 'normal',
                        fontWeight: '700',
                        lineHeight: 'normal',
                        textTransform: 'capitalize'
                    }}
                >
                    Archive old listing?
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Typography variant="body2" component="span" sx={{ mb: 2 }}>
                            Would you like to archive the previous listing? if so, please provide the date when the unit was leased
                        </Typography>
                        <Stack direction="column" spacing={2} sx={{ mt: 2 }}>
                            <Typography
                                variant="h4"
                                component="span"
                                aria-required
                                sx={{
                                    color: '#272727',
                                    fontSize: '12px',
                                    fontStyle: 'normal',
                                    fontWeight: '600'
                                }}
                            >
                                Lease Date <span style={{ color: 'red' }}>*</span>
                            </Typography>
                            <DatePicker
                                sx={{ mt: '5px !important' }}
                                value={selectedDate}
                                onChange={handleDateChange}
                                disableFuture
                                slotProps={{
                                    textField: {
                                        error: dateError,
                                        helperText: dateError ? 'Date is required' : ''
                                    }
                                }}
                            />
                        </Stack>
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ pr: 2.5 }}>
                    <Button
                        onClick={() => {
                            handleCloseTwo();
                        }}
                        variant="outlined"
                    >
                        No
                    </Button>
                    <LoadingButton
                        type="button"
                        variant="contained"
                        onClick={() => {
                            setOpenTwo(false);
                            setOpenThree(true);
                        }}
                        autoFocus
                        loading={loading}
                        disabled={!selectedDate}
                    >
                        Archive listing
                    </LoadingButton>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openThree}
                onClose={() => {
                    setUnitNm(null);
                    setOpenThree(false);
                    handleArchieveAndCreateNew();
                }}
                aria-labelledby="responsive-dialog-title"
                sx={{
                    '& .MuiPaper-root': {
                        width: '400px'
                    }
                }}
            >
                <DialogContent>
                    <DialogContentText>
                        <Typography variant="body2" component="span" sx={{ mb: 2 }}>
                            Would you like to duplicate it for a new unit? If so, please provide the unit id of new listing.
                        </Typography>
                        <TextField
                            value={unitNm}
                            onChange={(e) => setUnitNm(e.target.value)}
                            sx={{ mt: 1 }}
                            type="number"
                            placeholder="Enter New Unit Number"
                            required
                            fullWidth
                        />
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ pr: 2.5 }}>
                    <Button
                        sx={{ color: theme.palette.error.dark }}
                        onClick={() => {
                            setUnitNm(null);
                            setOpenThree(false);
                            handleArchieveAndCreateNew();
                        }}
                        color="secondary"
                    >
                        Cancel
                    </Button>
                    <LoadingButton
                        type="button"
                        variant="contained"
                        size="small"
                        onClick={() => handleArchieveAndCreateNew(true)}
                        autoFocus
                        loading={loading}
                        disabled={!selectedDate}
                    >
                        Create Duplicate
                    </LoadingButton>
                </DialogActions>
            </Dialog>

            {role === roles.ADMIN && (
                <EditedDataModal
                    openEdited={openEdited}
                    handleOpenEdited={handleOpenEdited}
                    handleCloseEdited={handleCloseEdited}
                    row={currentEditedData}
                />
            )}

            <TableRow
                hover
                role="checkbox"
                aria-checked={selected?.includes(row?.id)}
                tabIndex={-1}
                key={index}
                selected={selected?.includes(row?.id)}
            >
                {/* <TableCell padding="checkbox" sx={{ pl: 1, pr: 1 }} onClick={() => onSelectRow(row?.id)}>
                    <Checkbox
                        color="primary"
                        checked={selected?.includes(row?.id)}
                        inputProps={{
                            'aria-labelledby': `enhanced-table-checkbox-${index}`
                        }}
                    />
                </TableCell> */}

                {/* Approval Status  */}
                <TableCell sx={{ cursor: 'pointer', justifyContent: 'center' }}>
                    <Grid container alignItems="center" justifyContent="center">
                        <Button
                            sx={{
                                borderRadius: '5px',
                                border: `2px solid ${getBorderColor(row?.listingStatus, row?.completion)}`,
                                width: '110px',
                                fontSize: '12px',
                                fontWeight: '600',
                                height: '30px',
                                color: getBodyColor(row?.listingStatus, row?.completion),
                                display: 'flex',
                                gap: '7px'
                            }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none">
                                <circle cx="2" cy="2" r="2" fill={getBodyColor(row?.listingStatus, row?.completion)} />
                            </svg>

                            {getText(row?.listingStatus, row?.completion)}
                        </Button>

                        {/* <PublishButton
                            progress={100}
                            onClick={() => {
                                row?.listingStatus === 'APPROVED' && handleOpenLease();
                            }}
                            disabled={false}
                            text={row.listingStatus === 'APPROVED' ? 'UNPUBLISH' : 'DRAFT'}
                            isButton={row.listingStatus === 'APPROVED'}
                            bgColor={row.listingStatus === 'APPROVED' ? '#FFDEDE' : '#F3C62340'}
                            textColor={row.listingStatus === 'APPROVED' ? '#CE2828' : '#9D8E63'}
                        /> */}

                        {/* {row?.listingStatus !== 'APPROVED' ? (
                            <Box display="flex" alignItems="center">
                                <Chip
                                    // label={
                                    //     row?.listingStatus !== 'NONE'
                                    //         ? row?.listingStatus === 'APPROVED'
                                    //             ? 'PUBLISHED'
                                    //             : row?.listingStatus === 'REJECTED'
                                    //             ? 'UNPUBLISHED'
                                    //             : 'DRAFT'
                                    //         : `${row?.completion}%`
                                    // }
                                    label={`${row?.completion}%`}
                                    size="small"
                                    sx={{
                                        padding: '0px 12px',
                                        background: `${
                                            row?.completion < 50
                                                ? theme.palette.error.light
                                                : row?.completion < 90
                                                ? theme.palette.warning.light + 80 // Orange for 40%-80%
                                                : theme.palette.success.light + 60 // Green for 80%-95%
                                        }`,
                                        color: `${
                                            row?.completion < 50
                                                ? theme.palette.error.dark // Bright red for < 40%
                                                : row?.completion < 90
                                                ? theme.palette.warning.dark // Orange for 40%-80%
                                                : theme.palette.success.dark // Green for 80%-95%
                                        }`
                                    }}
                                />
                            </Box>
                        ) : (
                            <Box
                                display="flex"
                                alignItems="center"
                                onClick={() => {
                                    handleOpenLease();
                                }}
                            >
                                <Chip
                                    label={`UnPublish`}
                                    size="small"
                                    sx={{
                                        cursor: 'pointer',
                                        padding: '0px',
                                        background: `${theme.palette.error.light}`,
                                        color: `${theme.palette.error.dark}`
                                    }}
                                />
                            </Box>
                        )} */}
                    </Grid>
                </TableCell>

                {/* Listing ID  */}
                <TableCell sx={{ cursor: 'pointer', textAlign: 'center' }}>
                    <Grid container alignItems="center" justifyContent="center">
                        {row?.listing_id ? (
                            <Typography align="left" varint="subtitle1" component="div">
                                {row?.listing_id}
                            </Typography>
                        ) : (
                            <Typography align="left" varint="subtitle1" component="div">
                                -
                            </Typography>
                            // <PublishButton
                            //     progress={row?.completion}
                            //     onClick={(e) => {
                            //         if (row?.completion >= 100 && (row?.listingStatus === 'NONE' || row.listingStatus === 'REJECTED')) {
                            //             e.stopPropagation();
                            //             if (Object.keys(terms).length > 0 && !terms?.userAgreement && !termsReqSend) {
                            //                 setOpenTerms(true);
                            //                 return;
                            //             }
                            //             handleOpenModal();
                            //         }
                            //     }}
                            //     disabled={(row?.completion >= 100 && row?.listingStatus === 'PENDING') || row?.listingStatus === 'APPROVED'}
                            //     isButton={row?.completion >= 100 && row?.listingStatus !== 'PENDING' && row?.listingStatus !== 'APPROVED'}
                            //     text={
                            //         row.listingStatus === 'APPROVED'
                            //             ? 'Publishing'
                            //             : row?.listingStatus === 'PENDING'
                            //             ? 'Publishing'
                            //             : 'Publish'
                            //     }
                            // />
                        )}
                    </Grid>
                </TableCell>

                {role !== roles.APARTMENT_MANAGER && (
                    <TableCell
                        sx={{
                            cursor: 'pointer',
                            '& span': {
                                width: 'max-content'
                            }
                        }}
                        padding="none"
                    >
                        {row?.specialUserAccess?.length > 0 ? (
                            renderManagers(row?.specialAccessUserNames)
                        ) : (
                            // <Grid container alignItems="center" justifyContent="center" flexDirection="row" gap="5px">
                            //     <Typography
                            //         align="left"
                            //         variant="subtitle1"
                            //         component="div"
                            //         sx={{ width: 'max-content', justifyContent: 'center', textAlign: 'center' }}
                            //         onClick={() => {
                            //             if (role !== roles.ADMIN) return;

                            //             const accessUsers = row?.specialUserAccess?.filter(
                            //                 (e) => e?.user?.roleName === roles.APARTMENT_MANAGER
                            //             );
                            //             if (accessUsers?.length) {
                            //                 const id = accessUsers[0]?.user?.id;
                            //                 navigate(`/customers/${id}`);
                            //             }
                            //         }}
                            //     >
                            //         {row?.specialAccessUserNames}
                            //     </Typography>
                            // </Grid>
                            <Grid container alignItems="left" flexDirection="column" justifyContent={'center'} textAlign={'center'}>
                                -
                            </Grid>
                        )}
                    </TableCell>
                )}

                {/* Complex Name  */}
                {role !== roles.APARTMENT_MANAGER && (
                    <TableCell>
                        <Grid container alignItems="center" justifyContent="center">
                            <Typography
                                align="left"
                                variant="subtitle1"
                                component="div"
                                sx={{ width: 'max-content', justifyContent: 'center', textAlign: 'center' }}
                                style={{
                                    color:
                                        highlightedKeys.includes('complexName') && row?.listingStatus !== 'APPROVED' ? '#FFB915' : 'inherit'
                                }}
                            >
                                {`${row?.generalInformation?.complexName || '-'}`}
                            </Typography>
                        </Grid>
                    </TableCell>
                )}

                {/* Floor Plan  */}
                <TableCell sx={{ cursor: 'pointer', justifyContent: 'center' }}>
                    <Grid container alignItems="center" justifyContent="center">
                        <Typography
                            align="left"
                            variant="subtitle1"
                            component="div"
                            sx={{
                                width: 'max-content',
                                justifyContent: 'center',
                                textAlign: 'center',
                                color:
                                    highlightedKeys.includes('floorPlanName') && row?.listingStatus !== 'APPROVED' ? '#FFB915' : 'inherit'
                            }}
                        >
                            {row?.generalInformation?.floorPlanName ? row?.generalInformation?.floorPlanName?.split('-').join('') : '-'}
                        </Typography>
                    </Grid>
                </TableCell>

                {/* Unit #  */}
                <TableCell sx={{ cursor: 'pointer', justifyContent: 'center' }}>
                    <Grid container alignItems="center" justifyContent="center" onClick={() => navigate(`/listing/details/${row?.id}`)}>
                        <Typography
                            align="left"
                            variant="subtitle1"
                            component="div"
                            sx={{
                                width: 'max-content',
                                justifyContent: 'center',
                                fontWeight: '600',
                                textAlign: 'center',
                                color: '#0E7AF0'
                            }}
                        >
                            {row?.locationInformation?.unit ? row.locationInformation.unit : '-'}
                        </Typography>
                    </Grid>
                </TableCell>

                {/* Price  */}
                <TableCell sx={{ cursor: 'pointer', justifyContent: 'center' }}>
                    <Grid container alignItems="center" justifyContent="center">
                        <Typography
                            align="left"
                            variant="subtitle1"
                            component="div"
                            sx={{ width: 'max-content', justifyContent: 'center', textAlign: 'center' }}
                            style={{
                                color: highlightedKeys.includes('listPrice') && row?.listingStatus !== 'APPROVED' ? '#FFB915' : 'inherit'
                            }}
                        >
                            {`$${row?.listingInformation?.listPrice ? Number(row?.listingInformation?.listPrice).toLocaleString() : '0'}`}
                        </Typography>
                    </Grid>
                </TableCell>

                {/* Price Updated At  */}
                {/* <TableCell sx={{ cursor: 'pointer', justifyContent: 'center' }}>
                    <Grid container alignItems="center" justifyContent="center"></Grid>
                </TableCell> */}

                {/* Sq Ft */}
                {role !== roles.ADMIN && (
                    <TableCell sx={{ cursor: 'pointer', justifyContent: 'center' }}>
                        <Grid container alignItems="center" justifyContent="center">
                            <Typography
                                align="left"
                                variant="subtitle1"
                                component="div"
                                sx={{ width: 'max-content', justifyContent: 'center', textAlign: 'center' }}
                                style={{
                                    color:
                                        highlightedKeys.includes('livingArea') && row?.listingStatus !== 'APPROVED' ? '#FFB915' : 'inherit'
                                }}
                            >
                                {row?.generalInformation?.livingArea ? row.generalInformation.livingArea : '-'}
                            </Typography>
                        </Grid>
                    </TableCell>
                )}

                {/* BEDS  */}
                {role !== roles.ADMIN && (
                    <TableCell sx={{ cursor: 'pointer', justifyContent: 'center' }}>
                        <Grid container alignItems="center" justifyContent="center">
                            <Typography
                                align="left"
                                variant="subtitle1"
                                component="div"
                                sx={{ width: 'max-content', justifyContent: 'center', textAlign: 'center' }}
                                style={{
                                    color:
                                        highlightedKeys.includes('mainLevelBedrooms') && row?.listingStatus !== 'APPROVED'
                                            ? '#FFB915'
                                            : 'inherit'
                                }}
                            >
                                {row?.generalInformation?.mainLevelBedrooms ? row.generalInformation.mainLevelBedrooms : '-'}
                            </Typography>
                        </Grid>
                    </TableCell>
                )}

                {/* BATHS  */}
                {role !== roles.ADMIN && (
                    <TableCell sx={{ cursor: 'pointer', justifyContent: 'center' }}>
                        <Grid container alignItems="center" justifyContent="center">
                            <Typography
                                align="left"
                                variant="subtitle1"
                                component="div"
                                sx={{ width: 'max-content', justifyContent: 'center', textAlign: 'center' }}
                                style={{
                                    color:
                                        highlightedKeys.includes('bathroomsFull') && row?.listingStatus !== 'APPROVED'
                                            ? '#FFB915'
                                            : 'inherit'
                                }}
                            >
                                {row?.generalInformation?.bathroomsFull ? row.generalInformation.bathroomsFull : '-'}
                            </Typography>
                        </Grid>
                    </TableCell>
                )}

                {/* Archieve Approval Status  */}
                {role === roles.ADMIN && row?.currentStatus === propertyStatus?.ARCHIEVED && (
                    <TableCell sx={{ cursor: 'pointer', justifyContent: 'center' }}>
                        <Grid container alignItems="center" justifyContent="center">
                            <Box display="flex" alignItems="center">
                                <Chip
                                    label={row?.archiveStatus}
                                    size="small"
                                    sx={{
                                        padding: '0px',
                                        background: `${
                                            row?.archiveStatus === 'APPROVED'
                                                ? theme.palette.success.light + 60 // Green for Approved
                                                : row?.archiveStatus === 'REJECTED'
                                                ? theme.palette.error.light // Red for Rejected
                                                : theme.palette.warning.light + 80 // Orange for other statuses
                                        }`,
                                        color: `${
                                            row?.archiveStatus === 'APPROVED'
                                                ? theme.palette.success.dark // Green for Approved
                                                : row?.archiveStatus === 'REJECTED'
                                                ? theme.palette.error.dark // Red for Rejected
                                                : theme.palette.warning.dark // Orange for other statuses
                                        }`
                                    }}
                                />
                            </Box>
                        </Grid>
                    </TableCell>
                )}

                <TableCell>
                    <Box sx={{ display: 'flex' }}>
                        <Tooltip title="Property Details">
                            <IconButton size="large" aria-label="more options" onClick={() => navigate(`/listing/details/${row?.id}`)}>
                                <ArticleIcon color="primary" sx={{ fontSize: '1.3rem' }} />
                            </IconButton>
                        </Tooltip>

                        <Box
                            sx={{
                                cursor: 'pointer',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'column'
                            }}
                        >
                            <Box>
                                {role === roles.ADMIN && (
                                    <Typography
                                        variant="subtitle1"
                                        component="div"
                                        sx={{ width: 'max-content', justifyContent: 'center', textAlign: 'center' }}
                                        onClick={() => {
                                            if (oldValueCount && row?.listingStatus !== 'APPROVED') {
                                                handleModalOpening(row);
                                            }
                                        }}
                                    >
                                        {oldValueCount && row?.listingStatus !== 'APPROVED'
                                            ? `${oldValueCount} recent updates`
                                            : `${getTimeDifference(row?.updatedAt, 'update')}`}
                                    </Typography>
                                )}

                                <Typography
                                    align="left"
                                    variant="subtitle1"
                                    component="div"
                                    sx={{ fontSize: '12px', width: 'max-content' }}
                                >
                                    {`Price updated ${moment(row?.listingInformation?.listPriceUpdatedAt).fromNow() || '--'}`}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </TableCell>

                {/* LISTING RATE FOR ADMIN  */}
                {/* {role === roles.ADMIN && (
                    <TableCell sx={{ cursor: 'pointer', justifyContent: 'center' }}>
                        <Grid container alignItems="center" justifyContent="center">
                            <TextField id="listing_rate" label="Listing Rate" placeholder="$200" variant="standard" />
                        </Grid>
                    </TableCell>
                )} */}

                {/* ACTION FOR ADMIN  */}
                <TableCell
                    align="center"
                    sx={{
                        pr: 3,
                        position: 'sticky',
                        right: 0,
                        backgroundColor: '#F8F8FA',
                        zIndex: 1,
                        boxShadow: '-2px 6px 8px 0px rgba(0, 0, 0, 0.15)'
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Box sx={{ mr: 2, width: '120px' }}>
                            {row?.completion !== 100 || isArchivedPage ? (
                                <Box display="flex" alignItems="center" flexDirection="column" mt={2}>
                                    <Box width="100%" mr={1}>
                                        <LinearProgress
                                            variant="determinate"
                                            value={row?.completion}
                                            sx={{
                                                height: 6,
                                                borderRadius: 5,
                                                backgroundColor: '#e0e0df',
                                                '& .MuiLinearProgress-bar': {
                                                    borderRadius: 5,
                                                    backgroundColor: '#4caf50' // Green color for progress
                                                }
                                            }}
                                        />
                                    </Box>
                                    <Typography
                                        variant="body1"
                                        mt={1}
                                        sx={{
                                            color: '#272727',
                                            fontSize: '10px',
                                            fontStyle: 'normal',
                                            fontWeight: '600',
                                            lineHeight: 'normal',
                                            textTransform: 'capitalize'
                                        }}
                                    >
                                        {`${row?.completion}% Form Complete`}
                                    </Typography>
                                </Box>
                            ) : row?.listingStatus === 'APPROVED' ? (
                                <Button
                                    sx={{
                                        bgcolor: '#272727',
                                        borderRadius: '5px',
                                        fontSize: '12px',
                                        fontStyle: 'normal',
                                        fontWeight: '600',
                                        padding: '10px 20px',
                                        maxWidth: '100%',
                                        border: '1px solid #272727',
                                        background: 'white'
                                    }}
                                    onClick={() => {
                                        row?.listingStatus === 'APPROVED' && handleOpenLease();
                                    }}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path
                                            d="M9.58738 12.6955C9.6296 12.769 9.69048 12.8301 9.76388 12.8726C9.83727 12.9151 9.92057 12.9375 10.0054 12.9375C10.0902 12.9375 10.1735 12.9151 10.2469 12.8726C10.3203 12.8301 10.3811 12.769 10.4234 12.6955L12.5794 8.9615C12.622 8.88816 12.6444 8.80488 12.6445 8.72008C12.6446 8.63527 12.6224 8.55194 12.58 8.4785C12.5376 8.40506 12.4765 8.3441 12.403 8.30179C12.3295 8.25947 12.2462 8.2373 12.1614 8.2375L11.6874 8.2375C11.6239 8.23776 11.561 8.22549 11.5023 8.20138C11.4436 8.17728 11.3902 8.14182 11.3453 8.09703C11.3003 8.05225 11.2646 7.99903 11.2403 7.94042C11.2159 7.88181 11.2034 7.81896 11.2034 7.7555L11.2034 4.6895C11.2044 4.6257 11.1928 4.56233 11.1692 4.50305C11.1456 4.44378 11.1104 4.38978 11.0658 4.3442C11.0211 4.29862 10.9679 4.26236 10.9091 4.23752C10.8503 4.21268 10.7872 4.19976 10.7234 4.1995L9.28738 4.1995C9.22323 4.19922 9.15968 4.21176 9.10044 4.23636C9.0412 4.26096 8.98747 4.29714 8.94239 4.34277C8.89732 4.38841 8.8618 4.44258 8.83793 4.50212C8.81406 4.56166 8.80231 4.62536 8.80338 4.6895L8.80338 7.7555C8.80338 7.88333 8.75259 8.00593 8.6622 8.09632C8.57181 8.18672 8.44921 8.2375 8.32138 8.2375L7.84738 8.2375C7.76257 8.2373 7.67921 8.25947 7.60572 8.30179C7.53223 8.3441 7.4712 8.40506 7.4288 8.4785C7.38639 8.55194 7.36412 8.63527 7.36422 8.72008C7.36432 8.80488 7.3868 8.88816 7.42938 8.9615L9.58738 12.6955Z"
                                            fill="#272727"
                                        />
                                        <path
                                            d="M4.74512 15.833L15.2601 15.833C15.4128 15.833 15.5593 15.7891 15.6673 15.711C15.7753 15.6328 15.8359 15.5268 15.8359 15.4163C15.8359 15.3058 15.7753 15.1999 15.6673 15.1217C15.5593 15.0436 15.4128 14.9997 15.2601 14.9997L4.74512 14.9997C4.59239 14.9997 4.44592 15.0436 4.33793 15.1217C4.22994 15.1999 4.16927 15.3058 4.16927 15.4163C4.16927 15.5268 4.22994 15.6328 4.33793 15.711C4.44592 15.7891 4.59239 15.833 4.74512 15.833Z"
                                            fill="#272727"
                                        />
                                    </svg>
                                    Unpublish
                                </Button>
                            ) : (
                                <Button
                                    variant="contained"
                                    sx={{
                                        bgcolor: '#272727',
                                        borderRadius: '5px',
                                        fontSize: '12px',
                                        fontStyle: 'normal',
                                        fontWeight: '600',
                                        padding: '10px 28px',
                                        maxWidth: '100%'
                                    }}
                                    disabled={row?.listingStatus === 'PENDING'}
                                    onClick={(e) => {
                                        if (row?.completion >= 100 && (row?.listingStatus === 'NONE' || row.listingStatus === 'REJECTED')) {
                                            e.stopPropagation();
                                            if (Object.keys(terms).length > 0 && !terms?.userAgreement && !termsReqSend) {
                                                setOpenTerms(true);
                                                return;
                                            }
                                            handleOpenModal();
                                        }
                                    }}
                                >
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g id="noun-publish-4181075 1">
                                            <g id="Layer 2">
                                                <path
                                                    id="Vector"
                                                    d="M10.4165 7.3045C10.3743 7.23096 10.3134 7.16985 10.24 7.12736C10.1666 7.08487 10.0833 7.0625 9.99853 7.0625C9.91373 7.0625 9.83042 7.08487 9.75703 7.12736C9.68364 7.16985 9.62276 7.23096 9.58053 7.3045L7.42453 11.0385C7.38195 11.1118 7.35948 11.1951 7.35938 11.2799C7.35927 11.3647 7.38155 11.4481 7.42395 11.5215C7.46635 11.5949 7.52738 11.6559 7.60088 11.6982C7.67437 11.7405 7.75773 11.7627 7.84253 11.7625H8.31653C8.38 11.7622 8.44289 11.7745 8.5016 11.7986C8.56031 11.8227 8.61368 11.8582 8.65865 11.903C8.70362 11.9478 8.7393 12.001 8.76365 12.0596C8.788 12.1182 8.80053 12.181 8.80053 12.2445V15.3105C8.79947 15.3743 8.81109 15.4377 8.83471 15.4969C8.85834 15.5562 8.89349 15.6102 8.93814 15.6558C8.9828 15.7014 9.03605 15.7376 9.09483 15.7625C9.1536 15.7873 9.21672 15.8002 9.28053 15.8005H10.7165C10.7807 15.8008 10.8442 15.7882 10.9035 15.7636C10.9627 15.739 11.0164 15.7029 11.0615 15.6572C11.1066 15.6116 11.1421 15.5574 11.166 15.4979C11.1898 15.4383 11.2016 15.3746 11.2005 15.3105V12.2445C11.2005 12.1167 11.2513 11.9941 11.3417 11.9037C11.4321 11.8133 11.5547 11.7625 11.6825 11.7625H12.1565C12.2413 11.7627 12.3247 11.7405 12.3982 11.6982C12.4717 11.6559 12.5327 11.5949 12.5751 11.5215C12.6175 11.4481 12.6398 11.3647 12.6397 11.2799C12.6396 11.1951 12.6171 11.1118 12.5745 11.0385L10.4165 7.3045Z"
                                                    fill="white"
                                                />
                                                <path
                                                    id="Vector_2"
                                                    d="M15.2568 4.16699H4.74186C4.58914 4.16699 4.44267 4.21089 4.33468 4.28903C4.22669 4.36717 4.16602 4.47315 4.16602 4.58366C4.16602 4.69417 4.22669 4.80015 4.33468 4.87829C4.44267 4.95643 4.58914 5.00033 4.74186 5.00033H15.2568C15.4096 5.00033 15.556 4.95643 15.664 4.87829C15.772 4.80015 15.8327 4.69417 15.8327 4.58366C15.8327 4.47315 15.772 4.36717 15.664 4.28903C15.556 4.21089 15.4096 4.16699 15.2568 4.16699Z"
                                                    fill="white"
                                                />
                                            </g>
                                        </g>
                                    </svg>
                                    Publish
                                </Button>
                            )}
                        </Box>
                        {row?.currentStatus === propertyStatus?.DEFAULT && (
                            <Tooltip
                                title="Edit"
                                onClick={() => {
                                    handleEdit(row);
                                    handleMenuClose();
                                }}
                            >
                                <IconButton>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <rect x="0.5" y="0.5" width="23" height="23" rx="4.5" stroke="#E6E6E6" />
                                        <path
                                            d="M18.7725 8.14373C19.0758 7.84044 19.0758 7.33495 18.7725 7.04722L16.9528 5.22747C16.665 4.92418 16.1596 4.92418 15.8563 5.22747L14.4254 6.6506L17.3416 9.56687M5 16.0837V19H7.91626L16.5173 10.3912L13.601 7.47493L5 16.0837Z"
                                            fill="#272727"
                                        />
                                    </svg>
                                </IconButton>
                            </Tooltip>
                        )}

                        <IconButton aria-label="more options" aria-controls="dropdown-menu" aria-haspopup="true" onClick={handleMenuClick}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <rect x="0.5" y="0.5" width="23" height="23" rx="4.5" stroke="#E6E6E6" />
                                <path
                                    d="M16 12C16 11.4696 16.2107 10.9609 16.5858 10.5858C16.9609 10.2107 17.4696 10 18 10C18.5304 10 19.0391 10.2107 19.4142 10.5858C19.7893 10.9609 20 11.4696 20 12C20 12.5304 19.7893 13.0391 19.4142 13.4142C19.0391 13.7893 18.5304 14 18 14C17.4696 14 16.9609 13.7893 16.5858 13.4142C16.2107 13.0391 16 12.5304 16 12ZM10 12C10 11.4696 10.2107 10.9609 10.5858 10.5858C10.9609 10.2107 11.4696 10 12 10C12.5304 10 13.0391 10.2107 13.4142 10.5858C13.7893 10.9609 14 11.4696 14 12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14C11.4696 14 10.9609 13.7893 10.5858 13.4142C10.2107 13.0391 10 12.5304 10 12ZM4 12C4 11.4696 4.21071 10.9609 4.58579 10.5858C4.96086 10.2107 5.46957 10 6 10C6.53043 10 7.03914 10.2107 7.41421 10.5858C7.78929 10.9609 8 11.4696 8 12C8 12.5304 7.78929 13.0391 7.41421 13.4142C7.03914 13.7893 6.53043 14 6 14C5.46957 14 4.96086 13.7893 4.58579 13.4142C4.21071 13.0391 4 12.5304 4 12ZM5 12C5 12.2652 5.10536 12.5196 5.29289 12.7071C5.48043 12.8946 5.73478 13 6 13C6.26522 13 6.51957 12.8946 6.70711 12.7071C6.89464 12.5196 7 12.2652 7 12C7 11.7348 6.89464 11.4804 6.70711 11.2929C6.51957 11.1054 6.26522 11 6 11C5.73478 11 5.48043 11.1054 5.29289 11.2929C5.10536 11.4804 5 11.7348 5 12ZM11 12C11 12.2652 11.1054 12.5196 11.2929 12.7071C11.4804 12.8946 11.7348 13 12 13C12.2652 13 12.5196 12.8946 12.7071 12.7071C12.8946 12.5196 13 12.2652 13 12C13 11.7348 12.8946 11.4804 12.7071 11.2929C12.5196 11.1054 12.2652 11 12 11C11.7348 11 11.4804 11.1054 11.2929 11.2929C11.1054 11.4804 11 11.7348 11 12ZM17 12C17 12.2652 17.1054 12.5196 17.2929 12.7071C17.4804 12.8946 17.7348 13 18 13C18.2652 13 18.5196 12.8946 18.7071 12.7071C18.8946 12.5196 19 12.2652 19 12C19 11.7348 18.8946 11.4804 18.7071 11.2929C18.5196 11.1054 18.2652 11 18 11C17.7348 11 17.4804 11.1054 17.2929 11.2929C17.1054 11.4804 17 11.7348 17 12Z"
                                    fill="#272727"
                                />
                            </svg>
                        </IconButton>
                        <Menu
                            id="dropdown-menu"
                            icon
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleMenuClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right'
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right'
                            }}
                        >
                            {(row?.currentStatus === propertyStatus?.DEFAULT || row?.currentStatus === propertyStatus?.ARCHIEVED) && (
                                <MenuItem
                                    onClick={() => {
                                        handleDelete(row?.id);
                                        handleMenuClose();
                                    }}
                                >
                                    <DeleteIcon color="error" sx={{ fontSize: '1.2rem', mr: 1 }} />
                                    Delete
                                </MenuItem>
                            )}
                            {row?.completion >= 99 &&
                                (row?.listingStatus === 'PENDING' || row?.listingStatus === 'NONE') &&
                                role === roles.ADMIN &&
                                row?.currentStatus === propertyStatus?.DEFAULT && (
                                    <>
                                        <MenuItem
                                            onClick={() => {
                                                handleApproveRequest(row);
                                                handleMenuClose();
                                            }}
                                        >
                                            <FileDownloadDoneIcon color="success" sx={{ fontSize: '1.2rem', mr: 1 }} />
                                            Approve
                                        </MenuItem>
                                        <MenuItem
                                            onClick={() => {
                                                handleRejectRequest(row);
                                                handleMenuClose();
                                            }}
                                        >
                                            <CloseIcon color="error" sx={{ fontSize: '1.2rem', mr: 1 }} />
                                            Reject
                                        </MenuItem>
                                    </>
                                )}

                            {row?.archiveStatus === archievedStatus.PENDING &&
                                role === roles.ADMIN &&
                                row?.currentStatus === propertyStatus?.ARCHIEVED && (
                                    <>
                                        <MenuItem
                                            onClick={() => {
                                                handleApproveArchieveRequest(row, archievedStatus.APPROVED);
                                                handleMenuClose();
                                            }}
                                        >
                                            <FileDownloadDoneIcon color="success" sx={{ fontSize: '1.2rem', mr: 1 }} />
                                            Approve
                                        </MenuItem>
                                        <MenuItem
                                            onClick={() => {
                                                handleApproveArchieveRequest(row, archievedStatus.REJECTED);
                                                handleMenuClose();
                                            }}
                                        >
                                            <CloseIcon color="error" sx={{ fontSize: '1.2rem', mr: 1 }} />
                                            Reject
                                        </MenuItem>
                                    </>
                                )}

                            {(role === roles?.REGIONAL_MANAGER || role === roles?.MARKETING_MANAGER || role === roles?.ADMIN) &&
                                row?.currentStatus === propertyStatus?.DEFAULT && (
                                    <MenuItem
                                        onClick={() => {
                                            openShareAccess(row?.id);
                                            handleMenuClose();
                                        }}
                                    >
                                        <VpnKeyOutlined color="primary" sx={{ fontSize: '1.2rem', mr: 1 }} />
                                        Share Access
                                    </MenuItem>
                                )}

                            {role === roles?.ADMIN && row?.listing_id && row?.currentStatus !== propertyStatus?.TRASHED && (
                                <MenuItem
                                    onClick={() => {
                                        handleAnalyticsOpen(row);
                                        handleMenuClose();
                                    }}
                                >
                                    <VisibilityIcon color="primary" sx={{ fontSize: '1.2rem', mr: 1 }} />
                                    View Analytics
                                </MenuItem>
                            )}
                            {row?.currentStatus === propertyStatus?.DEFAULT && (
                                <MenuItem
                                    onClick={() => {
                                        createNewComplexDuplicateLisitng(row);
                                        handleMenuClose();
                                        // navigate(`/listing/${row?.id}?duplicate=YES&complexSpecific=YES`);
                                    }}
                                >
                                    <ContentCopyIcon color="primary" sx={{ fontSize: '1.2rem', mr: 1 }} />
                                    Duplicate Complex Specific
                                </MenuItem>
                            )}
                            {role === roles.ADMIN && row?.currentStatus === propertyStatus?.DEFAULT && (
                                <MenuItem
                                    onClick={() => {
                                        createNewEntireDuplicateLisitng(row.id);
                                        handleMenuClose();
                                    }}
                                >
                                    <ContentCopyIcon color="primary" sx={{ fontSize: '1.2rem', mr: 1 }} />
                                    Duplicate Property
                                </MenuItem>
                            )}
                            {/* {row?.currentStatus === propertyStatus?.DEFAULT && (
                           <MenuItem
                               onClick={() => {
                                   navigate(`/listing/${row?.id}?duplicate=YES&unitSpecific=YES`);
                                   handleMenuClose();
                               }}
                           >
                               <ContentCopyIcon color="primary" sx={{ fontSize: '1.2rem', mr: 1 }} />
                               Duplicate Unit Specific
                           </MenuItem>
                       )} */}
                            {(row?.currentStatus === propertyStatus?.DEFAULT ||
                                (row?.currentStatus === propertyStatus?.ARCHIEVED && row?.archiveStatus === archievedStatus?.APPROVED)) && (
                                <MenuItem
                                    onClick={() => {
                                        handleArchieve(row);
                                        handleMenuClose();
                                    }}
                                >
                                    <ArchiveIcon color="primary" sx={{ fontSize: '1.2rem', mr: 1 }} />
                                    {row?.currentStatus === propertyStatus?.DEFAULT
                                        ? 'Archive Listing'
                                        : row?.currentStatus === propertyStatus?.ARCHIEVED
                                        ? 'UnArchive Listing'
                                        : null}
                                </MenuItem>
                            )}
                            {row?.currentStatus === propertyStatus?.ARCHIEVED && (
                                <MenuItem
                                    onClick={() => {
                                        handleDuplicate(row?.id);
                                        handleMenuClose();
                                    }}
                                >
                                    <ContentCopyIcon color="primary" sx={{ fontSize: '1.2rem', mr: 1 }} />
                                    Duplicate and Active
                                </MenuItem>
                            )}

                            {row?.currentStatus === propertyStatus?.TRASHED && (
                                <MenuItem
                                    onClick={() => {
                                        handleRestore(row?.id);
                                        handleMenuClose();
                                    }}
                                >
                                    <RestoreIcon color="primary" sx={{ fontSize: '1.2rem', mr: 1 }} />
                                    Restore
                                </MenuItem>
                            )}
                            {row?.currentStatus === propertyStatus?.TRASHED && (
                                <MenuItem
                                    onClick={() => {
                                        handleDelete(row?.id);
                                        handleMenuClose();
                                    }}
                                >
                                    <DeleteIcon color="error" sx={{ fontSize: '1.2rem', mr: 1 }} />
                                    Permanently Delete
                                </MenuItem>
                            )}
                        </Menu>
                    </Box>
                </TableCell>
            </TableRow>
        </>
    );
}

export default ListingTableRow;
